import { AppSubjectEnum } from '../../../shared/modules/authz';

/**
 * Report type values
 *
 * @description These are the other records that a report record can be associated
 * with and these values are a subset of the values in the AppSubjectEnum.
 */
export enum ReportTypeEnum {
	SYSTEM = AppSubjectEnum.SYSTEM,

	CUSTOMER = AppSubjectEnum.CUSTOMER,
	LOCATION = AppSubjectEnum.LOCATION,
	SUPPLIER = AppSubjectEnum.SUPPLIER,
	AGENT = AppSubjectEnum.AGENT,

	VEHICLE = AppSubjectEnum.VEHICLE,
	VEHICLE_DAMAGE = AppSubjectEnum.VEHICLE_DAMAGE,
	VEHICLE_INSURANCE = AppSubjectEnum.VEHICLE_INSURANCE,
	VEHICLE_INSURANCE_CLAIM = AppSubjectEnum.VEHICLE_INSURANCE_CLAIM,
	VEHICLE_MAINTENANCE = AppSubjectEnum.VEHICLE_MAINTENANCE,
	VEHICLE_ROAD_TAX = AppSubjectEnum.VEHICLE_ROAD_TAX,
	VEHICLE_ROAD_WORTHY_CHECK = AppSubjectEnum.VEHICLE_ROAD_WORTHY_CHECK,
	RENTAL_AGREEMENT = AppSubjectEnum.RENTAL_AGREEMENT,
	RENTAL_RESERVATION = AppSubjectEnum.RENTAL_RESERVATION,
	TRANSACTION = AppSubjectEnum.TRANSACTION,
}
